module.exports = __webpack_public_path__ + "static/media/0-icon.2c592793.png";